import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Footer() {
  const subscribe = (e) => {
    e.preventDefault();
    toast.success("You're on the list — one useful email a month, no noise.");
    e.target.reset();
  };
  return (
    <footer className="border-t border-white/10 bg-white/5">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img
                src="/gstudio-icon.png"
                alt="G-Studio logo"
                className="h-10 w-10 rounded-xl object-cover shadow-md shadow-blue-600/20"
              />
              <span className="font-display text-xl font-bold tracking-tight text-white">
                G-Studio<span className="text-blue-400">.</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              We design and build business websites — expertly developed, mobile-first and launched in days.
              Call (507) 841-1801 to get started.
            </p>
            <form onSubmit={subscribe} className="mt-6 flex max-w-sm gap-2" data-testid="footer-newsletter-form">
              <input
                type="email"
                required
                placeholder="Your work email"
                data-testid="footer-newsletter-input"
                className="w-full rounded-full border border-white/15 bg-white/5/5 px-4 py-2.5 text-sm text-white outline-none transition-colors placeholder:text-slate-400 focus:border-blue-400"
              />
              <button
                type="submit"
                data-testid="footer-newsletter-submit"
                className="flex items-center gap-1 rounded-full bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-500/100"
              >
                Join <ArrowRight className="h-3.5 w-3.5" />
              </button>
            </form>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Studio</p>
            <ul className="mt-4 space-y-2.5 text-sm font-medium text-slate-400">
              <li><a data-testid="footer-link-services" href="/#services" className="hover:text-blue-400">Services</a></li>
              <li><a data-testid="footer-link-process" href="/#process" className="hover:text-blue-400">Process</a></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-blue-400">About</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Get Started</p>
            <ul className="mt-4 space-y-2.5 text-sm font-medium text-slate-400">
              <li><Link data-testid="footer-link-pricing" to="/pricing" className="hover:text-blue-400">Pricing</Link></li>
              <li><a data-testid="footer-link-call" href="tel:+15078411801" className="hover:text-blue-400">Call (507) 841-1801</a></li>
              <li><a data-testid="footer-link-book" href="/#book" className="hover:text-blue-400">Book a Free Call</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Support</p>
            <ul className="mt-4 space-y-2.5 text-sm font-medium text-slate-400">
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-blue-400">Contact</Link></li>
              <li><Link data-testid="footer-link-faq" to="/faq" className="hover:text-blue-400">FAQ</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="hover:text-blue-400">Terms of Service</Link></li>
              <li><Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-blue-400">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-refund" to="/refund-policy" className="hover:text-blue-400">Refund Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-400">© 2026 G-Studio. All rights reserved.</p>
          <p className="font-mono2 text-xs text-slate-400">WE BUILD. YOU GROW.</p>
        </div>
      </div>
    </footer>
  );
}
